import { Autocomplete, Tab, Tabs } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
    EditRoomBody,
    ErrorFieldResponse,
    PenyewaData,
} from "../../constants/types";

import { yupResolver } from "@hookform/resolvers/yup";
import CloseIcon from "@mui/icons-material/Close";
import LoadingButton from "@mui/lab/LoadingButton";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import defaultAxios, { AxiosError } from "axios";
import NumberFormat from "react-number-format";
import { useMutation, useQueryClient } from "react-query";
import Swal from "sweetalert2";
import * as yup from "yup";
import axios from "../../services/axios";
import useDetailHistoryComingRoom from "../../services/queries/useDetailHistoryComingRoom";
import useDetailHistoryRoom from "../../services/queries/useDetailHistoryRoom";
import useDetailHistoryRoomExtends from "../../services/queries/useDetailHistoryRoomExtends";
import toRupiah from "../../utils/toRupiah";
import ModalActiveRuangan from "../ModalActiveRuangan/ModalActiveRuangan";
import ModalNonActiveRuangan from "../ModalNonActiveRuangan/ModalNonActiveRuangan";

import Tooltip from "@mui/material/Tooltip";

import { ModifierArguments } from "@popperjs/core";
import DatePicker from "react-datepicker";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

interface IModalDetailRuanganProps {
    isOpenModalDetailRuangan: boolean;
    closeModalDetailRuangan: () => void;
    dataLanggananMember?: EditRoomBody;
    ukm: { id: number; nama: string };
    roomId: number;
    kapasitas: number;
    nama: string;
    isAktif: 0 | 1;
    hargaSewaBulananMember: number;
    hargaSewaBulananNonMember: number;
    hargaSewaMember?: number;
    hargaSewaNonMember?: number;
    jenisSewa: string;
}

type Body = {
    ukmId: number | undefined;
    nama: string;
    kapasitas: number;
    jenisSewa: string;
    hargaSewaMember?: string;
    hargaSewaNonMember?: string;
    hargaSewaBulananMember?: string;
    hargaSewaBulananNonMember?: string;
};

type ExtendBody = {
    tanggalInvoice: string;
    tanggalMulai?: string;
    tanggalBerakhir?: string;
    tanggal?: string;
    jamMulai?: string;
    jamBerakhir?: string;
    periodeMingguan?: string;
    tipeHarga: string;
    nominalHarga: number;
    keterangan?: string;
};

type DateFilter = [Date | null, Date | null];

const schema = yup.object({
    nama: yup
        .string()
        .required("Kolom wajib diisi")
        .max(50, "Nama ruangan terlalu panjang"),
    kapasitas: yup
        .number()
        .typeError("Kapasitas harus berupa angka")
        .required("Kapasitas wajib diisi")
        .min(1, "Kapasitas minimal 1"),
    jenisSewa: yup.string().required("Jenis Sewa wajib dipilih"),
    hargaSewaMember: yup.string().when("jenisSewa", {
        is: (jenisSewa: string) =>
            jenisSewa === "jam" || jenisSewa === "mingguan",
        then: yup.string().required("Harga sewa member wajib diisi"),
        otherwise: yup.string().notRequired(),
    }),
    hargaSewaNonMember: yup.string().when("jenisSewa", {
        is: (jenisSewa: string) =>
            jenisSewa === "jam" || jenisSewa === "mingguan",
        then: yup.string().required("Harga sewa non-member wajib diisi"),
        otherwise: yup.string().notRequired(),
    }),
    hargaSewaBulananMember: yup.string().when("jenisSewa", {
        is: "bulanan",
        then: yup.string().required("Harga sewa bulanan member wajib diisi"),
        otherwise: yup.string().notRequired(),
    }),
    hargaSewaBulananNonMember: yup.string().when("jenisSewa", {
        is: "bulanan",
        then: yup
            .string()
            .required("Harga sewa bulanan non-member wajib diisi"),
        otherwise: yup.string().notRequired(),
    }),
});

const extendSchema = yup.object({
    tanggalInvoice: yup.string().required("Tanggal invoice wajib diisi"),
    tanggalMulai: yup.string().when("$jenisSewa", {
        is: (jenisSewa: string) => ["mingguan", "bulanan"].includes(jenisSewa),
        then: yup.string().required("Tanggal mulai wajib diisi"),
        otherwise: yup.string().optional(),
    }),
    tanggalBerakhir: yup.string().when("$jenisSewa", {
        is: (jenisSewa: string) => ["bulanan"].includes(jenisSewa),
        then: yup.string().required("Tanggal berakhir wajib diisi"),
        otherwise: yup.string().optional(),
    }),
    tanggal: yup.string().when("$jenisSewa", {
        is: "jam",
        then: yup.string().required("Tanggal wajib diisi"),
        otherwise: yup.string().optional(),
    }),
    jamMulai: yup.string().when("$jenisSewa", {
        is: "jam",
        then: yup.string().required("Jam mulai wajib diisi"),
        otherwise: yup.string().optional(),
    }),
    jamBerakhir: yup.string().when("$jenisSewa", {
        is: "jam",
        then: yup.string().required("Jam berakhir wajib diisi"),
        otherwise: yup.string().optional(),
    }),
    periodeMingguan: yup.string().when("$jenisSewa", {
        is: "mingguan",
        then: yup.string().required("Periode mingguan wajib dipilih"),
        otherwise: yup.string().optional(),
    }),
    tipeHarga: yup.string().required("Tipe harga wajib dipilih"),
    nominalHarga: yup
        .number()
        .required("Nominal harga wajib diisi")
        .min(1, "Nominal harga minimal 1"),
});

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel({ children, value, index, ...other }: TabPanelProps) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ paddingY: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const CustomInput = React.forwardRef(
    ({ value, onClick, error, disabled, placeholder }: any, ref: any) => (
        <Stack
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            direction="row"
            width="100%"
            bgcolor="#FFFF"
            height="60px"
            sx={{
                border: error ? "1px solid red" : "1px solid #cbcbcb",
                borderRadius: "4px",
                padding: 2,
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.6 : 1,
            }}
            onClick={disabled ? undefined : onClick}
            ref={ref}
        >
            <Typography color={value ? "inherit" : "text.secondary"}>
                {value || placeholder}
            </Typography>
        </Stack>
    ),
);

const ModalDetailRuangan = ({
    isOpenModalDetailRuangan,
    closeModalDetailRuangan,
    dataLanggananMember,
    ukm,
    roomId,
    kapasitas,
    nama,
    isAktif,
    hargaSewaBulananMember,
    hargaSewaBulananNonMember,
    hargaSewaMember,
    hargaSewaNonMember,
    jenisSewa,
}: IModalDetailRuanganProps) => {
    const theme = useTheme();
    const moment = require("moment");
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("sm", "md"));

    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [isExtendLoading, setIsExtendLoading] = useState(false);

    const formatDateTime = (dateTime: string) => {
        return moment(dateTime).format("D MMMM YYYY HH:mm");
    };
    const [value, setValue] = React.useState(0);

    const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const initialValues = useMemo(
        () => ({
            ukm: ukm ? { id: ukm.id, nama: ukm.nama } : undefined,
            nama: nama || "",
            kapasitas: kapasitas || 0,
            jenisSewa: jenisSewa || "",
            hargaSewaMember: hargaSewaBulananMember?.toString() || "",
            hargaSewaNonMember: hargaSewaBulananNonMember?.toString() || "",
            hargaSewaBulananMember: hargaSewaBulananMember?.toString() || "",
            hargaSewaBulananNonMember:
                hargaSewaBulananNonMember?.toString() || "",
        }),
        [
            ukm,
            nama,
            kapasitas,
            jenisSewa,
            hargaSewaBulananMember,
            hargaSewaBulananNonMember,
        ],
    );

    const {
        handleSubmit,
        control,
        formState: { errors },
        setError,
        setValue: setFormValue,
        clearErrors,
        reset,
        watch,
    } = useForm<EditRoomBody>({
        resolver: yupResolver(schema),
        defaultValues: initialValues,
    });

    const {
        handleSubmit: handleSubmitExtend,
        control: controlExtend,
        formState: { errors: errorsExtend },
        setError: setErrorExtend,
        setValue: setValueExtend,
        clearErrors: clearErrorsExtend,
    } = useForm<ExtendBody>({
        resolver: yupResolver(extendSchema),
        defaultValues: {
            tanggalInvoice: new Date().toISOString().split("T")[0],
            tanggalMulai: "",
            tanggalBerakhir: "",
            tipeHarga: "",
            nominalHarga: 0,
        },
    });

    const {
        data: detailRoom,
        refetch: refetchDetailRoom,
        isLoading: isLoadingHistory,
    } = useDetailHistoryRoom(roomId, isOpenModalDetailRuangan);

    const { data: detailRoomExtends, refetch: refetchDetailRoomExtends } =
        useDetailHistoryRoomExtends(roomId, isOpenModalDetailRuangan);

    const {
        data: detailHistoryComingRoom,
        refetch: refetchDetailHistoryComingRoom,
        isLoading: isLoadingHistoryComingRoom,
    } = useDetailHistoryComingRoom(roomId, isOpenModalDetailRuangan);

    const [excludedDateRanges, setExcludedDateRanges] = useState<
        Array<{ start: Date; end: Date }>
    >([]);
    const [selectedHarga, setSelectedHarga] = useState<string | null>(null);
    const [isCustomPrice, setIsCustomPrice] = useState<boolean>(false);
    const [dateRange, setDateRange] = useState<DateFilter>([null, null]);
    const [startDate, endDate] = dateRange;
    const [selectedDate, setSelectedDate] = useState<Date | null>(null);
    const [timeRange, setTimeRange] = useState<[string, string]>(["", ""]);
    const [actualEndDate, setActualEndDate] = useState<Date | null>(null);

    const currentJenisSewa = watch("jenisSewa");

    const generateTimeOptions = () => {
        const options = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 30) {
                const timeString = `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;
                options.push(timeString);
            }
        }
        return options;
    };

    const timeOptions = generateTimeOptions();

    const getNextAvailableTime = (
        currentTime: string,
        duration: number = 30,
    ): string => {
        const [hours, minutes] = currentTime.split(":").map(Number);

        const totalMinutes = hours * 60 + minutes + duration;

        let newHours = Math.floor(totalMinutes / 60) % 24;
        let newMinutes = totalMinutes % 60;

        return `${newHours.toString().padStart(2, "0")}:${newMinutes.toString().padStart(2, "0")}`;
    };

    const getNextDateIfNeeded = (
        currentDate: Date,
        startTime: string,
        endTime: string,
    ): Date => {
        const [startHours] = startTime.split(":").map(Number);
        const [endHours] = endTime.split(":").map(Number);

        if (
            endHours < startHours ||
            (endHours === startHours && endTime < startTime)
        ) {
            const nextDate = new Date(currentDate);
            nextDate.setDate(nextDate.getDate() + 1);
            return nextDate;
        }

        return currentDate;
    };

    const getHistoryData = (): PenyewaData[] => {
        if (!detailRoom || !detailRoom || !Array.isArray(detailRoom)) return [];
        return detailRoom;
    };

    const getHistoryComingData = (): PenyewaData[] => {
        if (!detailHistoryComingRoom || !Array.isArray(detailHistoryComingRoom))
            return [];
        return detailHistoryComingRoom;
    };

    const isCurrentlyRented = () => {
        const historyData = getHistoryData();
        if (historyData.length === 0) return false;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return historyData.some((item) => {
            try {
                const startDate = new Date(item.awalSewa);
                const endDate = new Date(item.akhirSewa);

                startDate.setHours(0, 0, 0, 0);
                endDate.setHours(0, 0, 0, 0);

                return today >= startDate && today <= endDate;
            } catch (error) {
                console.error("Error parsing date:", error);
                return false;
            }
        });
    };

    const getCurrentRenter = (): PenyewaData | null => {
        const historyData = getHistoryData();
        if (historyData.length === 0) return null;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        return (
            historyData.find((item) => {
                try {
                    const startDate = new Date(item.awalSewa);
                    const endDate = new Date(item.akhirSewa);

                    startDate.setHours(0, 0, 0, 0);
                    endDate.setHours(0, 0, 0, 0);

                    return today >= startDate && today <= endDate;
                } catch (error) {
                    console.error("Error parsing date:", error);
                    return false;
                }
            }) || null
        );
    };

    useEffect(() => {
        const historyData = getHistoryData();
        if (historyData.length > 0) {
            const excludedRanges = historyData
                .map((item) => {
                    try {
                        const startDate = new Date(item.awalSewa);
                        const endDate = new Date(item.akhirSewa);
                        return {
                            start: startDate,
                            end: endDate,
                        };
                    } catch (error) {
                        console.error("Error parsing date:", error);
                        return null;
                    }
                })
                .filter(Boolean) as Array<{ start: Date; end: Date }>;

            setExcludedDateRanges(excludedRanges);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detailRoom]);

    const isDateInExcludedRanges = (date: Date) => {
        return excludedDateRanges.some((range) => {
            return date >= range.start && date <= range.end;
        });
    };

    const filterPassedTime = (time: Date) => {
        return !isDateInExcludedRanges(time);
    };

    useEffect(() => {
        if (detailRoomExtends && value === 1) {
            const today = new Date();

            // Reset semua field terlebih dahulu
            setValueExtend(
                "tanggalInvoice",
                new Date().toISOString().split("T")[0],
            );
            setValueExtend("tanggalMulai", "");
            setValueExtend("tanggalBerakhir", "");
            setValueExtend("tanggal", "");
            setValueExtend("jamMulai", "");
            setValueExtend("jamBerakhir", "");
            setValueExtend("periodeMingguan", "1");

            // Set nilai berdasarkan jenis sewa
            if (currentJenisSewa === "jam") {
                // Untuk jam, set tanggal hari ini dan jam berikutnya
                setSelectedDate(today);
                setValueExtend("tanggal", today.toISOString().split("T")[0]);

                const lastEndTime =
                    detailRoomExtends.jamBerakhir?.substring(0, 5) || "00:00";
                const nextStartTime = getNextAvailableTime(lastEndTime, 30);
                const nextEndTime = getNextAvailableTime(nextStartTime, 60); // Default 1 jam

                setTimeRange([nextStartTime, nextEndTime]);
                setValueExtend("jamMulai", nextStartTime);
                setValueExtend("jamBerakhir", nextEndTime);
            } else if (currentJenisSewa === "mingguan") {
                // Untuk mingguan, set mulai dari hari setelah tanggal berakhir
                const lastEndDate = new Date(detailRoomExtends.tanggalBerakhir);
                const nextStartDate = new Date(lastEndDate);
                nextStartDate.setDate(nextStartDate.getDate() + 1);

                setDateRange([nextStartDate, null]);
                setValueExtend(
                    "tanggalMulai",
                    nextStartDate.toISOString().split("T")[0],
                );
                setValueExtend("periodeMingguan", "1");
            } else if (currentJenisSewa === "bulanan") {
                // Untuk bulanan, set mulai dari hari setelah tanggal berakhir
                const lastEndDate = new Date(detailRoomExtends.tanggalBerakhir);
                const nextStartDate = new Date(lastEndDate);
                nextStartDate.setDate(nextStartDate.getDate() + 1);

                const nextEndDate = new Date(nextStartDate);
                nextEndDate.setMonth(nextEndDate.getMonth() + 1);

                setDateRange([nextStartDate, nextEndDate]);
                setValueExtend(
                    "tanggalMulai",
                    nextStartDate.toISOString().split("T")[0],
                );
                setValueExtend(
                    "tanggalBerakhir",
                    nextEndDate.toISOString().split("T")[0],
                );
            }

            // Set harga berdasarkan tipe harga terakhir
            if (detailRoomExtends.tipeHargaTerakhir) {
                let hargaType = "";
                let displayHarga = "";

                if (detailRoomExtends.tipeHargaTerakhir === "member") {
                    hargaType = "member";
                    displayHarga = "Member";
                    setIsCustomPrice(false);
                    setValueExtend(
                        "nominalHarga",
                        currentJenisSewa === "bulanan"
                            ? hargaSewaMember || 0
                            : hargaSewaMember || 0,
                    );
                } else if (
                    detailRoomExtends.tipeHargaTerakhir === "nonMember"
                ) {
                    hargaType = "nonMember";
                    displayHarga = "Non Member";
                    setIsCustomPrice(false);
                    setValueExtend(
                        "nominalHarga",
                        currentJenisSewa === "bulanan"
                            ? hargaSewaMember || 0
                            : hargaSewaMember || 0,
                    );
                } else if (detailRoomExtends.tipeHargaTerakhir === "custom") {
                    hargaType = "custom";
                    displayHarga = "Custom";
                    setIsCustomPrice(true);
                    setValueExtend(
                        "nominalHarga",
                        detailRoomExtends.nominalTagihan || 0,
                    );
                }

                setSelectedHarga(displayHarga);
                setValueExtend("tipeHarga", hargaType);
            }

            clearErrorsExtend();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detailRoomExtends, value, setValueExtend, currentJenisSewa]);

    // PERBAIKAN UTAMA: useEffect untuk mengatur data otomatis ketika membuka tab Perpanjang
    useEffect(() => {
        if (detailRoomExtends && value === 1 && currentJenisSewa === "jam") {
            const today = new Date();
            const dataDate = new Date(detailRoomExtends.tanggal);

            const lastStartTime =
                detailRoomExtends.jamMulai?.substring(0, 5) || "00:00";
            const lastEndTime =
                detailRoomExtends.jamBerakhir?.substring(0, 5) || "00:00";

            setSelectedDate(null);
            setTimeRange(["", ""]);

            if (dataDate.toDateString() === today.toDateString()) {
                setSelectedDate(today);
                setValueExtend("tanggal", today.toISOString().split("T")[0]);

                const nextStartTime = getNextAvailableTime(lastEndTime, 30);
                const [lastStartHours, lastStartMinutes] = lastStartTime
                    .split(":")
                    .map(Number);
                const [lastEndHours, lastEndMinutes] = lastEndTime
                    .split(":")
                    .map(Number);

                let durationMinutes =
                    lastEndHours * 60 +
                    lastEndMinutes -
                    (lastStartHours * 60 + lastStartMinutes);
                if (durationMinutes < 0) durationMinutes += 24 * 60;

                const nextEndTime = getNextAvailableTime(
                    nextStartTime,
                    durationMinutes,
                );

                setTimeRange([nextStartTime, nextEndTime]);
                setValueExtend("jamMulai", nextStartTime);
                setValueExtend("jamBerakhir", nextEndTime);

                const newActualEndDate = getNextDateIfNeeded(
                    today,
                    nextStartTime,
                    nextEndTime,
                );
                setActualEndDate(newActualEndDate);
            } else {
                setSelectedDate(today);
                setValueExtend("tanggal", today.toISOString().split("T")[0]);

                setTimeRange(["08:00", "09:00"]);
                setValueExtend("jamMulai", "08:00");
                setValueExtend("jamBerakhir", "09:00");

                const newActualEndDate = getNextDateIfNeeded(
                    today,
                    "08:00",
                    "09:00",
                );
                setActualEndDate(newActualEndDate);
            }

            if (detailRoomExtends.tipeHargaTerakhir) {
                let hargaType = "";
                let displayHarga = "";

                if (detailRoomExtends.tipeHargaTerakhir === "member") {
                    hargaType = "member";
                    displayHarga = "Member";
                    setIsCustomPrice(false);
                    setValueExtend(
                        "nominalHarga",
                        detailRoomExtends.hargaSewaMember || 0,
                    );
                } else if (
                    detailRoomExtends.tipeHargaTerakhir === "nonMember"
                ) {
                    hargaType = "nonMember";
                    displayHarga = "Non Member";
                    setIsCustomPrice(false);
                    setValueExtend(
                        "nominalHarga",
                        detailRoomExtends.hargaSewaNonMember || 0,
                    );
                } else if (detailRoomExtends.tipeHargaTerakhir === "custom") {
                    hargaType = "custom";
                    displayHarga = "Custom";
                    setIsCustomPrice(true);
                    setValueExtend(
                        "nominalHarga",
                        detailRoomExtends.nominalTagihan || 0,
                    );
                }

                setSelectedHarga(displayHarga);
                setValueExtend("tipeHarga", hargaType);
            }

            clearErrorsExtend("tanggal");
            clearErrorsExtend("jamMulai");
            clearErrorsExtend("jamBerakhir");
            clearErrorsExtend("tipeHarga");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detailRoomExtends, value, setValueExtend, currentJenisSewa]);

    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: async (values: {
            body: Body;
            isEdit: boolean;
            id?: number;
        }) => {
            const { body } = values;

            const formData = new FormData();
            if (body.ukmId !== undefined) {
                formData.append("ukmId", String(body.ukmId));
            }
            formData.append("nama", body.nama);
            formData.append("kapasitas", String(body.kapasitas));
            formData.append("jenisSewa", body.jenisSewa);

            if (
                body.jenisSewa.toLowerCase() === "jam" ||
                body.jenisSewa.toLowerCase() === "mingguan"
            ) {
                formData.append("hargaSewaMember", body.hargaSewaMember || "");
                formData.append(
                    "hargaSewaNonMember",
                    body.hargaSewaNonMember || "",
                );
            } else if (body.jenisSewa.toLowerCase() === "bulanan") {
                formData.append(
                    "hargaSewaBulananMember",
                    body.hargaSewaBulananMember || "",
                );
                formData.append(
                    "hargaSewaBulananNonMember",
                    body.hargaSewaBulananNonMember || "",
                );
            }

            formData.append("_method", "put");
        },
    });

    const extendMutation = useMutation({
        mutationFn: async (values: ExtendBody) => {
            const res = await axios.post(
                `/api/mruangans/${roomId}/extends`,
                values,
            );
            return res.data;
        },
    });

    const onSubmit = (values: EditRoomBody) => {
        setIsButtonLoading(true);

        let body: Body = {
            ukmId: values.ukm?.id,
            nama: values.nama,
            kapasitas: values.kapasitas,
            jenisSewa: values.jenisSewa,
            // hargaSewaMember: "",
            // hargaSewaNonMember: "",
        };

        if (
            values.jenisSewa.toLowerCase() === "jam" ||
            values.jenisSewa.toLowerCase() === "mingguan"
        ) {
            body.hargaSewaMember = String(values.hargaSewaMember).replace(
                /\./g,
                "",
            );
            body.hargaSewaNonMember = String(values.hargaSewaNonMember).replace(
                /\./g,
                "",
            );
        } else if (values.jenisSewa.toLowerCase() === "bulanan") {
            body.hargaSewaBulananMember = String(
                values.hargaSewaBulananMember,
            ).replace(/\./g, "");
            body.hargaSewaBulananNonMember = String(
                values.hargaSewaBulananNonMember,
            ).replace(/\./g, "");
        }

        mutation.mutate(
            {
                body,
                isEdit: !!dataLanggananMember,
                id: roomId,
            },
            {
                onSuccess: () => {
                    queryClient.invalidateQueries("listRoom");
                    Swal.fire({
                        title: "Ruangan berhasil diubah",
                        position: "top-end",
                        showConfirmButton: false,
                        icon: "success",
                        toast: true,
                        timer: 3000,
                        timerProgressBar: true,
                        showCloseButton: true,
                        customClass: {
                            container: "my-swal",
                        },
                    });
                    closeModalDetailRuangan();
                    reset(initialValues);
                    setIsButtonLoading(false);
                },
                onError: (error) => {
                    if (defaultAxios.isAxiosError(error)) {
                        const serverError = error as AxiosError<
                            ErrorFieldResponse | undefined
                        >;
                        if (serverError && serverError?.response) {
                            const fieldError = serverError?.response?.data;
                            if (fieldError?.errors) {
                                Object.keys(fieldError.errors).forEach(
                                    (key) => {
                                        const errorMessage =
                                            fieldError.errors[key];
                                        setError(
                                            key as keyof typeof initialValues,
                                            {
                                                type: "manual",
                                                message: errorMessage[0],
                                            },
                                        );
                                    },
                                );
                            } else {
                                Swal.fire({
                                    title: `${
                                        fieldError?.message ??
                                        "Terjadi Kesalahan!"
                                    }`,
                                    position: "top-end",
                                    showConfirmButton: false,
                                    icon: "error",
                                    toast: true,
                                    timer: 3000,
                                    timerProgressBar: true,
                                    showCloseButton: true,
                                    customClass: {
                                        container: "my-swal",
                                    },
                                });
                            }
                        }
                    }
                    console.error(error);
                    setIsButtonLoading(false);
                },
            },
        );
    };

    const onSubmitExtend = (values: ExtendBody) => {
        // Validasi untuk jenis sewa jam
        if (currentJenisSewa === "jam") {
            if (!selectedDate) {
                setErrorExtend("tanggal", {
                    type: "manual",
                    message: "Tanggal wajib diisi",
                });
                return;
            }
            if (!timeRange[0] || !timeRange[1]) {
                setErrorExtend("jamMulai", {
                    type: "manual",
                    message: "Jam mulai dan jam berakhir wajib diisi",
                });
                return;
            }

            values.tanggal = selectedDate.toISOString().split("T")[0];
            values.jamMulai = timeRange[0];
            values.jamBerakhir = timeRange[1];

            const [startHour, startMinute] = timeRange[0]
                .split(":")
                .map(Number);
            const [endHour, endMinute] = timeRange[1].split(":").map(Number);

            let durationHours = endHour - startHour;
            let durationMinutes = endMinute - startMinute;

            if (durationMinutes < 0) {
                durationHours -= 1;
                durationMinutes += 60;
            }

            if (durationHours < 0) {
                durationHours += 24;
            }

            // const totalMinutes = durationHours * 60 + durationMinutes;
            // const hours = Math.floor(totalMinutes / 60);
            // const minutes = totalMinutes % 60;

            // let durationText = "";
            // if (hours > 0) {
            //     durationText += `${hours} jam`;
            // }
            // if (minutes > 0) {
            //     durationText += `${durationText ? " " : ""}${minutes} menit`;
            // }

            values.keterangan = `Perpanjangan sewa ruangan`;

            // Hapus field yang tidak diperlukan untuk jam
            delete values.tanggalMulai;
            delete values.tanggalBerakhir;
            delete values.periodeMingguan;
        }

        // Validasi untuk jenis sewa mingguan
        if (currentJenisSewa === "mingguan") {
            if (!values.tanggalMulai) {
                setErrorExtend("tanggalMulai", {
                    type: "manual",
                    message: "Tanggal mulai wajib diisi",
                });
                return;
            }

            const startDate = new Date(values.tanggalMulai);
            const weeks = parseInt(values.periodeMingguan || "1");
            const endDate = new Date(startDate);
            endDate.setDate(startDate.getDate() + weeks * 7 - 1);

            values.tanggalBerakhir = endDate.toISOString().split("T")[0];

            const hasConflict = excludedDateRanges.some((range) => {
                const rangeStart = new Date(range.start);
                const rangeEnd = new Date(range.end);
                rangeStart.setHours(0, 0, 0, 0);
                rangeEnd.setHours(0, 0, 0, 0);

                return (
                    (startDate >= rangeStart && startDate <= rangeEnd) ||
                    (endDate >= rangeStart && endDate <= rangeEnd) ||
                    (startDate <= rangeStart && endDate >= rangeEnd)
                );
            });

            if (hasConflict) {
                Swal.fire({
                    title: "Konflik Periode",
                    text: "Periode yang dipilih bertabrakan dengan periode sewa sebelumnya",
                    icon: "error",
                    confirmButtonText: "OK",
                });
                return;
            }

            values.keterangan = `Perpanjangan sewa ruangan`;

            delete values.tanggal;
            delete values.jamMulai;
            delete values.jamBerakhir;
        }

        if (currentJenisSewa === "bulanan") {
            if (!values.tanggalMulai || !values.tanggalBerakhir) {
                if (!values.tanggalMulai) {
                    setErrorExtend("tanggalMulai", {
                        type: "manual",
                        message: "Tanggal mulai wajib diisi",
                    });
                }
                if (!values.tanggalBerakhir) {
                    setErrorExtend("tanggalBerakhir", {
                        type: "manual",
                        message: "Tanggal berakhir wajib diisi",
                    });
                }
                return;
            }

            const startDate = new Date(values.tanggalMulai);
            const endDate = new Date(values.tanggalBerakhir);

            const hasConflict = excludedDateRanges.some((range) => {
                const rangeStart = new Date(range.start);
                const rangeEnd = new Date(range.end);
                rangeStart.setHours(0, 0, 0, 0);
                rangeEnd.setHours(0, 0, 0, 0);

                return (
                    (startDate >= rangeStart && startDate <= rangeEnd) ||
                    (endDate >= rangeStart && endDate <= rangeEnd) ||
                    (startDate <= rangeStart && endDate >= rangeEnd)
                );
            });

            if (hasConflict) {
                Swal.fire({
                    title: "Konflik Periode",
                    text: "Periode yang dipilih bertabrakan dengan periode sewa sebelumnya",
                    icon: "error",
                    confirmButtonText: "OK",
                });
                return;
            }

            values.keterangan = `Perpanjangan sewa ruangan`;

            delete values.tanggal;
            delete values.jamMulai;
            delete values.jamBerakhir;
            delete values.periodeMingguan;
        }

        setIsExtendLoading(true);

        extendMutation.mutate(values, {
            onSuccess: () => {
                queryClient.invalidateQueries("listRoom");
                queryClient.invalidateQueries("detailHistoryRoomExclusive");
                queryClient.invalidateQueries(
                    "detailHistoryRoomSpecialExtends",
                );

                Swal.fire({
                    title: "Perpanjangan ruangan berhasil",
                    position: "top-end",
                    showConfirmButton: false,
                    icon: "success",
                    toast: true,
                    timer: 3000,
                    timerProgressBar: true,
                    showCloseButton: true,
                    customClass: {
                        container: "my-swal",
                    },
                });

                closeModalDetailRuangan();
                refetchDetailRoom();
                refetchDetailRoomExtends();
                refetchDetailHistoryComingRoom();
                setIsExtendLoading(false);
            },
            onError: (error) => {
                if (defaultAxios.isAxiosError(error)) {
                    const serverError = error as AxiosError<
                        ErrorFieldResponse | undefined
                    >;
                    if (serverError && serverError?.response) {
                        const fieldError = serverError?.response?.data;
                        if (fieldError?.errors) {
                            Object.keys(fieldError.errors).forEach((key) => {
                                const errorMessage = fieldError.errors[key];
                                setErrorExtend(key as keyof ExtendBody, {
                                    type: "manual",
                                    message: errorMessage[0],
                                });
                            });
                        } else {
                            Swal.fire({
                                title: `${
                                    fieldError?.message ?? "Terjadi Kesalahan!"
                                }`,
                                position: "top-end",
                                showConfirmButton: false,
                                icon: "error",
                                toast: true,
                                timer: 3000,
                                timerProgressBar: true,
                                showCloseButton: true,
                                customClass: {
                                    container: "my-swal",
                                },
                            });
                        }
                    }
                }
                console.error(error);
                setIsExtendLoading(false);
            },
        });
    };

    useEffect(() => {
        if (isOpenModalDetailRuangan) {
            if (dataLanggananMember) {
                reset({
                    ...dataLanggananMember,
                });
            } else {
                reset(initialValues);
            }
        }
    }, [reset, initialValues, isOpenModalDetailRuangan, dataLanggananMember]);

    const [isOpenModalNonActiveRuangan, setIsOpenModalNonActiveRuangan] =
        React.useState(false);

    const openModalNonActiveRuangan = () =>
        setIsOpenModalNonActiveRuangan(true);
    const closeModalNonActiveRuangan = () =>
        setIsOpenModalNonActiveRuangan(false);

    const [isOpenModalActiveRuangan, setIsOpenModalActiveRuangan] =
        React.useState(false);

    const openModalActiveRuangan = () => setIsOpenModalActiveRuangan(true);
    const closeModalActiveRuangan = () => setIsOpenModalActiveRuangan(false);

    const currentRenter = getCurrentRenter();

    const hasUpcomingBookings = () => {
        const upcomingData = getHistoryComingData();
        return upcomingData.length > 0;
    };

    const isNonActiveButtonDisabled = () => {
        return (
            isAktif === 1 && (currentRenter !== null || hasUpcomingBookings())
        );
    };

    const getNonActiveButtonTooltip = () => {
        if (isAktif === 0) return "";
        if (currentRenter !== null)
            return "Tidak dapat menonaktifkan ruangan yang sedang disewa";
        if (hasUpcomingBookings())
            return "Tidak dapat menonaktifkan ruangan yang memiliki booking mendatang";
        return "";
    };

    const getHargaLabel = () => {
        switch (currentJenisSewa) {
            case "jam":
                return "Harga Sewa/Jam";
            case "mingguan":
                return "Harga Sewa/Minggu";
            case "bulanan":
            default:
                return "Harga Sewa/Bulan";
        }
    };

    const renderHargaFields = () => {
        if (currentJenisSewa === "bulanan") {
            return (
                <>
                    <Grid item xs={6}>
                        <Typography mb={1}>{getHargaLabel()} Member</Typography>
                        <Controller
                            name={"hargaSewaBulananMember"}
                            control={control}
                            render={({ field, fieldState }) => (
                                <NumberFormat
                                    customInput={TextField}
                                    placeholder="Contoh: 5.500.000"
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    fullWidth
                                    variant="outlined"
                                    size="medium"
                                    error={!!fieldState?.error}
                                    helperText={
                                        fieldState?.error
                                            ? fieldState?.error.message
                                            : " "
                                    }
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Typography>Rp.</Typography>
                                            </InputAdornment>
                                        ),
                                    }}
                                    {...field}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography mb={1}>
                            {getHargaLabel()} Non Member
                        </Typography>
                        <Controller
                            name={"hargaSewaBulananNonMember"}
                            control={control}
                            render={({ field, fieldState }) => (
                                <NumberFormat
                                    customInput={TextField}
                                    placeholder="Contoh: 5.500.000"
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    fullWidth
                                    variant="outlined"
                                    size="medium"
                                    error={!!fieldState?.error}
                                    helperText={
                                        fieldState?.error
                                            ? fieldState?.error.message
                                            : " "
                                    }
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Typography>Rp.</Typography>
                                            </InputAdornment>
                                        ),
                                    }}
                                    {...field}
                                />
                            )}
                        />
                    </Grid>
                </>
            );
        } else {
            // Untuk jenis sewa jam dan mingguan
            return (
                <>
                    <Grid item xs={6}>
                        <Typography mb={1}>{getHargaLabel()} Member</Typography>
                        <Controller
                            name={"hargaSewaMember"}
                            control={control}
                            render={({ field, fieldState }) => (
                                <NumberFormat
                                    customInput={TextField}
                                    placeholder={
                                        currentJenisSewa === "jam"
                                            ? "Contoh: 50.000"
                                            : "Contoh: 350.000"
                                    }
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    fullWidth
                                    variant="outlined"
                                    size="medium"
                                    error={!!fieldState?.error}
                                    helperText={
                                        fieldState?.error
                                            ? fieldState?.error.message
                                            : " "
                                    }
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Typography>Rp.</Typography>
                                            </InputAdornment>
                                        ),
                                    }}
                                    {...field}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Typography mb={1}>
                            {getHargaLabel()} Non Member
                        </Typography>
                        <Controller
                            name={"hargaSewaNonMember"}
                            control={control}
                            render={({ field, fieldState }) => (
                                <NumberFormat
                                    customInput={TextField}
                                    placeholder={
                                        currentJenisSewa === "jam"
                                            ? "Contoh: 75.000"
                                            : "Contoh: 500.000"
                                    }
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    fullWidth
                                    variant="outlined"
                                    size="medium"
                                    error={!!fieldState?.error}
                                    helperText={
                                        fieldState?.error
                                            ? fieldState?.error.message
                                            : " "
                                    }
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Typography>Rp.</Typography>
                                            </InputAdornment>
                                        ),
                                    }}
                                    {...field}
                                />
                            )}
                        />
                    </Grid>
                </>
            );
        }
    };

    return (
        <Dialog
            maxWidth="md"
            fullScreen={isPhoneScreen}
            fullWidth={true}
            open={isOpenModalDetailRuangan}
            onClose={closeModalDetailRuangan}
            scroll="body"
            PaperProps={{
                sx: {
                    borderRadius: 1,
                },
            }}
            onClick={(e) => e.stopPropagation()}
        >
            <DialogTitle>
                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Typography variant="h6" fontWeight="bold">
                        {nama}
                    </Typography>

                    <IconButton onClick={closeModalDetailRuangan}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent
                dividers
                sx={{
                    padding: "20px 40px",
                }}
            >
                <Box>
                    <Box>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            variant="scrollable"
                            scrollButtons="auto"
                            aria-label="basic tabs example"
                        >
                            <Tab label="Detail Ruangan" {...a11yProps(0)} />

                            {isCurrentlyRented() && (
                                <Tab label="Perpanjang" {...a11yProps(1)} />
                            )}

                            <Tab label="Riwayat Sewa" {...a11yProps(2)} />

                            <Tab label="Booking Mendatang" {...a11yProps(3)} />
                        </Tabs>
                    </Box>

                    <TabPanel value={value} index={0}>
                        <Stack gap={6}>
                            <Grid container alignItems="center" spacing={2}>
                                <Grid item xs={12}>
                                    <Typography mb={1}>Nama Ruangan</Typography>

                                    <Controller
                                        name="nama"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                id="nama"
                                                inputProps={{
                                                    "data-testid": "input-nama",
                                                }}
                                                placeholder="Masukan Nama Ruangan"
                                                fullWidth
                                                variant="outlined"
                                                error={Boolean(errors.nama)}
                                                helperText={
                                                    errors.nama
                                                        ? errors.nama.message
                                                        : ""
                                                }
                                                {...field}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography mb={1}>
                                        Kapasitas Ruangan
                                    </Typography>

                                    <Controller
                                        name="kapasitas"
                                        control={control}
                                        render={({ field }) => (
                                            <TextField
                                                id="kapasitas"
                                                inputProps={{
                                                    "data-testid":
                                                        "input-kapasitas",
                                                }}
                                                placeholder="Contoh: 20"
                                                fullWidth
                                                variant="outlined"
                                                error={Boolean(
                                                    errors.kapasitas,
                                                )}
                                                helperText={
                                                    errors.kapasitas
                                                        ? errors.kapasitas
                                                              .message
                                                        : ""
                                                }
                                                {...field}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={6} mt="20px">
                                    <Typography mb={1}>Jenis Sewa</Typography>

                                    <Controller
                                        name="jenisSewa"
                                        control={control}
                                        render={({ field }) => (
                                            <Autocomplete
                                                options={[
                                                    "Bulanan",
                                                    "Mingguan",
                                                    "Jam",
                                                ]}
                                                getOptionLabel={(option) =>
                                                    option
                                                }
                                                value={
                                                    field.value === "bulanan"
                                                        ? "Bulanan"
                                                        : field.value ===
                                                            "mingguan"
                                                          ? "Mingguan"
                                                          : field.value ===
                                                              "jam"
                                                            ? "Jam"
                                                            : field.value
                                                }
                                                disabled={isCurrentlyRented()}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        error={Boolean(
                                                            errors.jenisSewa,
                                                        )}
                                                        helperText={
                                                            errors.jenisSewa
                                                                ? errors
                                                                      .jenisSewa
                                                                      .message
                                                                : " "
                                                        }
                                                    />
                                                )}
                                                onChange={(_, newValueSewa) => {
                                                    if (newValueSewa) {
                                                        const valueForBackend =
                                                            newValueSewa.toLowerCase();
                                                        field.onChange(
                                                            valueForBackend,
                                                        );
                                                        clearErrors(
                                                            "jenisSewa",
                                                        );

                                                        // Clear all price fields when changing jenis sewa
                                                        setFormValue(
                                                            "hargaSewaMember",
                                                            "",
                                                        );
                                                        setFormValue(
                                                            "hargaSewaNonMember",
                                                            "",
                                                        );
                                                        setFormValue(
                                                            "hargaSewaBulananMember",
                                                            "",
                                                        );
                                                        setFormValue(
                                                            "hargaSewaBulananNonMember",
                                                            "",
                                                        );
                                                    } else {
                                                        field.onChange("");
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>

                                {renderHargaFields()}
                            </Grid>

                            <Stack
                                direction="row"
                                spacing={1.5}
                                width="100%"
                                sx={{
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                {isAktif === 0 && (
                                    <LoadingButton
                                        loading={isButtonLoading}
                                        loadingPosition="center"
                                        variant="contained"
                                        onClick={() => openModalActiveRuangan()}
                                        color="success"
                                    >
                                        Aktifkan
                                    </LoadingButton>
                                )}

                                {isAktif === 1 && (
                                    <Tooltip
                                        title={getNonActiveButtonTooltip()}
                                        arrow
                                    >
                                        <span>
                                            <LoadingButton
                                                loading={isButtonLoading}
                                                loadingPosition="center"
                                                variant="contained"
                                                onClick={() =>
                                                    openModalNonActiveRuangan()
                                                }
                                                color="error"
                                                disabled={isNonActiveButtonDisabled()}
                                            >
                                                Nonaktifkan
                                            </LoadingButton>
                                        </span>
                                    </Tooltip>
                                )}

                                {isAktif === 1 &&
                                    !isNonActiveButtonDisabled() && (
                                        <div style={{ visibility: "hidden" }}>
                                            <LoadingButton
                                                variant="contained"
                                                color="error"
                                            >
                                                Nonaktifkan
                                            </LoadingButton>
                                        </div>
                                    )}

                                <Stack direction="row" spacing={1.5}>
                                    <LoadingButton
                                        loadingPosition="center"
                                        variant="outlined"
                                        onClick={closeModalDetailRuangan}
                                    >
                                        Kembali
                                    </LoadingButton>

                                    <LoadingButton
                                        loading={isButtonLoading}
                                        loadingPosition="center"
                                        variant="contained"
                                        onClick={handleSubmit(onSubmit)}
                                        disabled={isButtonLoading}
                                        data-testid="simpan-ruangan"
                                    >
                                        Ubah
                                    </LoadingButton>
                                </Stack>
                            </Stack>
                        </Stack>
                    </TabPanel>

                    {isCurrentlyRented() && (
                        <TabPanel value={value} index={1}>
                            <Stack gap={6}>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item xs={12}>
                                        <Typography mb={1}>Penyewa</Typography>
                                        <TextField
                                            value={
                                                detailRoomExtends?.namaPenyewa ||
                                                ""
                                            }
                                            fullWidth
                                            variant="outlined"
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </Grid>

                                    {currentJenisSewa === "mingguan" ? (
                                        // Tampilan untuk jenis sewa mingguan
                                        <>
                                            <Grid item xs={6}>
                                                <Typography mb={1}>
                                                    Tanggal Mulai
                                                </Typography>
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={(date) => {
                                                        if (date) {
                                                            setDateRange([
                                                                date,
                                                                null,
                                                            ]);
                                                            setValueExtend(
                                                                "tanggalMulai",
                                                                date
                                                                    .toISOString()
                                                                    .split(
                                                                        "T",
                                                                    )[0],
                                                            );
                                                            clearErrorsExtend(
                                                                "tanggalMulai",
                                                            );
                                                        }
                                                    }}
                                                    dateFormat="dd/MM/yyyy"
                                                    minDate={
                                                        detailRoomExtends
                                                            ? new Date(
                                                                  new Date(
                                                                      detailRoomExtends.tanggalBerakhir,
                                                                  ).setDate(
                                                                      new Date(
                                                                          detailRoomExtends.tanggalBerakhir,
                                                                      ).getDate() +
                                                                          1,
                                                                  ),
                                                              )
                                                            : new Date()
                                                    }
                                                    filterDate={
                                                        filterPassedTime
                                                    }
                                                    customInput={
                                                        <CustomInput
                                                            value={
                                                                startDate
                                                                    ? startDate.toLocaleDateString(
                                                                          "id-ID",
                                                                      )
                                                                    : ""
                                                            }
                                                            error={Boolean(
                                                                errorsExtend.tanggalMulai,
                                                            )}
                                                            placeholder="Pilih Tanggal Mulai"
                                                        />
                                                    }
                                                />
                                                {errorsExtend.tanggalMulai && (
                                                    <FormHelperText error>
                                                        {
                                                            errorsExtend
                                                                .tanggalMulai
                                                                .message
                                                        }
                                                    </FormHelperText>
                                                )}
                                            </Grid>

                                            <Grid item xs={6} mt="20px">
                                                <Typography mb={1}>
                                                    Jumlah Minggu
                                                </Typography>
                                                <Controller
                                                    name="periodeMingguan"
                                                    control={controlExtend}
                                                    render={({ field }) => (
                                                        <Autocomplete
                                                            options={[
                                                                "1",
                                                                "2",
                                                                "3",
                                                                "4",
                                                                "5",
                                                                "6",
                                                                "7",
                                                                "8",
                                                            ]}
                                                            getOptionLabel={(
                                                                option,
                                                            ) =>
                                                                `${option} Minggu`
                                                            }
                                                            value={
                                                                field.value ||
                                                                "1"
                                                            }
                                                            onChange={(
                                                                _,
                                                                newValue,
                                                            ) => {
                                                                field.onChange(
                                                                    newValue ||
                                                                        "1",
                                                                );
                                                                clearErrorsExtend(
                                                                    "periodeMingguan",
                                                                );

                                                                if (
                                                                    startDate &&
                                                                    newValue
                                                                ) {
                                                                    const weeks =
                                                                        parseInt(
                                                                            newValue,
                                                                        );
                                                                    const endDate =
                                                                        new Date(
                                                                            startDate,
                                                                        );
                                                                    endDate.setDate(
                                                                        startDate.getDate() +
                                                                            weeks *
                                                                                7 -
                                                                            1,
                                                                    );
                                                                    setDateRange(
                                                                        [
                                                                            startDate,
                                                                            endDate,
                                                                        ],
                                                                    );
                                                                }
                                                            }}
                                                            renderInput={(
                                                                params,
                                                            ) => (
                                                                <TextField
                                                                    {...params}
                                                                    placeholder="Pilih Jumlah Minggu"
                                                                    variant="outlined"
                                                                    error={Boolean(
                                                                        errorsExtend.periodeMingguan,
                                                                    )}
                                                                    helperText={
                                                                        errorsExtend.periodeMingguan
                                                                            ? errorsExtend
                                                                                  .periodeMingguan
                                                                                  .message
                                                                            : " "
                                                                    }
                                                                />
                                                            )}
                                                        />
                                                    )}
                                                />
                                                {/* {startDate && (
                                                    <FormHelperText>
                                                        {`Periode: ${startDate.toLocaleDateString("id-ID")} - ${endDate ? endDate.toLocaleDateString("id-ID") : 'akan dihitung otomatis'}`}
                                                    </FormHelperText>
                                                )} */}
                                            </Grid>
                                        </>
                                    ) : currentJenisSewa === "bulanan" ? (
                                        <Grid item xs={12}>
                                            <Typography mb={1}>
                                                Periode Bulanan
                                            </Typography>

                                            <DatePicker
                                                className="range-filter"
                                                dateFormat="dd/MM/yyyy"
                                                selectsRange={true}
                                                startDate={startDate}
                                                endDate={endDate}
                                                minDate={
                                                    detailRoomExtends
                                                        ? new Date(
                                                              new Date(
                                                                  detailRoomExtends.tanggalBerakhir,
                                                              ).setDate(
                                                                  new Date(
                                                                      detailRoomExtends.tanggalBerakhir,
                                                                  ).getDate() +
                                                                      1,
                                                              ),
                                                          )
                                                        : new Date()
                                                }
                                                filterDate={filterPassedTime}
                                                onChange={(update) => {
                                                    const [start, end] =
                                                        update as DateFilter;
                                                    setDateRange([start, end]);

                                                    if (start) {
                                                        setValueExtend(
                                                            "tanggalMulai",
                                                            start
                                                                .toISOString()
                                                                .split("T")[0],
                                                        );
                                                        clearErrorsExtend(
                                                            "tanggalMulai",
                                                        );
                                                    }

                                                    if (end) {
                                                        setValueExtend(
                                                            "tanggalBerakhir",
                                                            end
                                                                .toISOString()
                                                                .split("T")[0],
                                                        );
                                                        clearErrorsExtend(
                                                            "tanggalBerakhir",
                                                        );
                                                    }
                                                }}
                                                monthsShown={
                                                    isPhoneScreen ||
                                                    isTabletScreen
                                                        ? 1
                                                        : 2
                                                }
                                                popperProps={{
                                                    modifiers: [
                                                        {
                                                            name: "preventOverflow",
                                                            options: {
                                                                boundary:
                                                                    "viewport",
                                                            },
                                                        },
                                                        {
                                                            name: "zIndexFix",
                                                            enabled: true,
                                                            phase: "write",
                                                            fn: ({
                                                                state,
                                                            }: ModifierArguments<any>) => {
                                                                state.styles.popper.zIndex =
                                                                    "1500";
                                                            },
                                                        },
                                                    ],
                                                }}
                                                customInput={
                                                    <Stack
                                                        display="flex"
                                                        justifyContent="space-between"
                                                        alignItems="center"
                                                        direction="row"
                                                        width="100%"
                                                        bgcolor="#FFFF"
                                                        height="60px"
                                                        sx={{
                                                            border:
                                                                errorsExtend.tanggalMulai ||
                                                                errorsExtend.tanggalBerakhir
                                                                    ? "1px solid red"
                                                                    : "1px solid #cbcbcb",
                                                            borderRadius: "4px",
                                                            padding: 2,
                                                        }}
                                                    >
                                                        <Typography>
                                                            {startDate
                                                                ? startDate.toLocaleDateString(
                                                                      "id-ID",
                                                                  )
                                                                : "Mulai"}{" "}
                                                            -{" "}
                                                            {endDate
                                                                ? endDate.toLocaleDateString(
                                                                      "id-ID",
                                                                  )
                                                                : "Selesai"}
                                                        </Typography>
                                                    </Stack>
                                                }
                                            />
                                            {(errorsExtend.tanggalMulai ||
                                                errorsExtend.tanggalBerakhir) && (
                                                <FormHelperText error>
                                                    {errorsExtend.tanggalMulai
                                                        ?.message ||
                                                        errorsExtend
                                                            .tanggalBerakhir
                                                            ?.message}
                                                </FormHelperText>
                                            )}
                                        </Grid>
                                    ) : (
                                        // Tampilan untuk jenis sewa jam
                                        <>
                                            <Grid item xs={6}>
                                                <Typography mb={1}>
                                                    Tanggal
                                                </Typography>
                                                <DatePicker
                                                    selected={selectedDate}
                                                    onChange={(date) => {
                                                        setSelectedDate(date);
                                                        if (date) {
                                                            setValueExtend(
                                                                "tanggal",
                                                                date
                                                                    .toISOString()
                                                                    .split(
                                                                        "T",
                                                                    )[0],
                                                            );
                                                            clearErrorsExtend(
                                                                "tanggal",
                                                            );
                                                        }
                                                    }}
                                                    dateFormat="dd/MM/yyyy"
                                                    minDate={new Date()}
                                                    filterDate={
                                                        filterPassedTime
                                                    }
                                                    customInput={
                                                        <CustomInput
                                                            value={
                                                                selectedDate
                                                                    ? selectedDate.toLocaleDateString(
                                                                          "id-ID",
                                                                      )
                                                                    : ""
                                                            }
                                                            error={Boolean(
                                                                errorsExtend.tanggal,
                                                            )}
                                                            placeholder="Pilih Tanggal"
                                                        />
                                                    }
                                                />
                                                {errorsExtend.tanggal && (
                                                    <FormHelperText error>
                                                        {
                                                            errorsExtend.tanggal
                                                                .message
                                                        }
                                                    </FormHelperText>
                                                )}
                                            </Grid>

                                            <Grid item xs={3}>
                                                <Typography mb={1}>
                                                    Jam Mulai
                                                </Typography>

                                                <Autocomplete
                                                    options={timeOptions}
                                                    value={timeRange[0]}
                                                    onChange={(_, newValue) => {
                                                        if (newValue) {
                                                            setTimeRange([
                                                                newValue,
                                                                timeRange[1],
                                                            ]);
                                                            setValueExtend(
                                                                "jamMulai",
                                                                newValue,
                                                            );
                                                            clearErrorsExtend(
                                                                "jamMulai",
                                                            );
                                                        }
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Jam Mulai"
                                                            variant="outlined"
                                                            error={Boolean(
                                                                errorsExtend.jamMulai,
                                                            )}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={3}>
                                                <Typography mb={1}>
                                                    Jam Akhir
                                                </Typography>

                                                <Autocomplete
                                                    options={timeOptions}
                                                    value={timeRange[1]}
                                                    onChange={(_, newValue) => {
                                                        if (newValue) {
                                                            setTimeRange([
                                                                timeRange[0],
                                                                newValue,
                                                            ]);
                                                            setValueExtend(
                                                                "jamBerakhir",
                                                                newValue,
                                                            );
                                                            clearErrorsExtend(
                                                                "jamBerakhir",
                                                            );
                                                        }
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Jam Berakhir"
                                                            variant="outlined"
                                                            error={Boolean(
                                                                errorsExtend.jamBerakhir,
                                                            )}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            {selectedDate &&
                                                timeRange[0] &&
                                                timeRange[1] &&
                                                actualEndDate && (
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                        >
                                                            Periode sewa:{" "}
                                                            {selectedDate.toLocaleDateString(
                                                                "id-ID",
                                                            )}{" "}
                                                            {timeRange[0]} -{" "}
                                                            {actualEndDate.toDateString() ===
                                                            selectedDate.toDateString()
                                                                ? timeRange[1]
                                                                : `${actualEndDate.toLocaleDateString("id-ID")} ${timeRange[1]}`}
                                                        </Typography>
                                                    </Grid>
                                                )}

                                            {(errorsExtend.jamMulai ||
                                                errorsExtend.jamBerakhir) && (
                                                <Grid item xs={12}>
                                                    <FormHelperText error>
                                                        {errorsExtend.jamMulai
                                                            ?.message ||
                                                            errorsExtend
                                                                .jamBerakhir
                                                                ?.message}
                                                    </FormHelperText>
                                                </Grid>
                                            )}
                                        </>
                                    )}

                                    {/* Field untuk harga dan nominal tagihan tetap sama */}
                                    <Grid item xs={6} mt="20px">
                                        <Typography mb={1}>
                                            Pilih Harga
                                        </Typography>

                                        <Autocomplete
                                            options={[
                                                "member",
                                                "nonMember",
                                                "custom",
                                            ]}
                                            getOptionLabel={(option) => {
                                                if (option === "member")
                                                    return "Member";
                                                if (option === "nonMember")
                                                    return "Non Member";
                                                return "Custom";
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    error={Boolean(
                                                        errorsExtend.tipeHarga,
                                                    )}
                                                    helperText={
                                                        errorsExtend.tipeHarga
                                                            ? errorsExtend
                                                                  .tipeHarga
                                                                  .message
                                                            : " "
                                                    }
                                                />
                                            )}
                                            value={
                                                selectedHarga
                                                    ? selectedHarga === "Member"
                                                        ? "member"
                                                        : selectedHarga ===
                                                            "Non Member"
                                                          ? "nonMember"
                                                          : "custom"
                                                    : ""
                                            }
                                            onChange={(_, newValue) => {
                                                const tipeHarga =
                                                    newValue || "";
                                                setSelectedHarga(
                                                    tipeHarga === "member"
                                                        ? "Member"
                                                        : tipeHarga ===
                                                            "nonMember"
                                                          ? "Non Member"
                                                          : "Custom",
                                                );

                                                if (tipeHarga) {
                                                    setValueExtend(
                                                        "tipeHarga",
                                                        tipeHarga,
                                                    );
                                                    clearErrorsExtend(
                                                        "tipeHarga",
                                                    );

                                                    if (
                                                        tipeHarga === "custom"
                                                    ) {
                                                        setIsCustomPrice(true);
                                                        setValueExtend(
                                                            "nominalHarga",
                                                            0,
                                                        );
                                                    } else {
                                                        setIsCustomPrice(false);
                                                        if (detailRoomExtends) {
                                                            if (
                                                                tipeHarga ===
                                                                "member"
                                                            ) {
                                                                setValueExtend(
                                                                    "nominalHarga",
                                                                    currentJenisSewa ===
                                                                        "bulanan"
                                                                        ? detailRoomExtends.hargaSewaBulananMember ||
                                                                              0
                                                                        : detailRoomExtends.hargaSewaMember ||
                                                                              0,
                                                                );
                                                            } else if (
                                                                tipeHarga ===
                                                                "nonMember"
                                                            ) {
                                                                setValueExtend(
                                                                    "nominalHarga",
                                                                    currentJenisSewa ===
                                                                        "bulanan"
                                                                        ? detailRoomExtends.hargaSewaBulananNonMember ||
                                                                              0
                                                                        : detailRoomExtends.hargaSewaNonMember ||
                                                                              0,
                                                                );
                                                            }
                                                        }
                                                    }
                                                } else {
                                                    setValueExtend(
                                                        "tipeHarga",
                                                        "",
                                                    );
                                                    setValueExtend(
                                                        "nominalHarga",
                                                        0,
                                                    );
                                                    setIsCustomPrice(false);
                                                }
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <Typography mb={1}>
                                            Nominal Tagihan
                                        </Typography>

                                        <Controller
                                            name={"nominalHarga"}
                                            control={controlExtend}
                                            render={({ field, fieldState }) => (
                                                <NumberFormat
                                                    customInput={TextField}
                                                    placeholder="Contoh: 5.500.000"
                                                    thousandSeparator="."
                                                    decimalSeparator=","
                                                    fullWidth
                                                    variant="outlined"
                                                    size="medium"
                                                    disabled={!isCustomPrice}
                                                    error={!!fieldState?.error}
                                                    helperText={
                                                        fieldState?.error &&
                                                        fieldState?.error
                                                            .message
                                                    }
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Typography>
                                                                    Rp.
                                                                </Typography>
                                                            </InputAdornment>
                                                        ),
                                                        readOnly:
                                                            !isCustomPrice,
                                                    }}
                                                    onValueChange={(values) => {
                                                        field.onChange(
                                                            values.floatValue,
                                                        );
                                                    }}
                                                    value={field.value}
                                                />
                                            )}
                                        />
                                    </Grid>
                                </Grid>

                                <Stack
                                    direction="row"
                                    spacing={1.5}
                                    width="100%"
                                    sx={{
                                        justifyContent: "flex-end",
                                    }}
                                >
                                    <LoadingButton
                                        loadingPosition="center"
                                        variant="outlined"
                                        onClick={closeModalDetailRuangan}
                                    >
                                        Kembali
                                    </LoadingButton>

                                    <LoadingButton
                                        loading={isExtendLoading}
                                        loadingPosition="center"
                                        variant="contained"
                                        onClick={handleSubmitExtend(
                                            onSubmitExtend,
                                        )}
                                        disabled={isExtendLoading}
                                    >
                                        Perpanjang
                                    </LoadingButton>
                                </Stack>
                            </Stack>
                        </TabPanel>
                    )}

                    <TabPanel value={value} index={isCurrentlyRented() ? 2 : 1}>
                        {isLoadingHistory ? (
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                minHeight={200}
                            >
                                <Typography>
                                    Memuat data riwayat penyewaan...
                                </Typography>
                            </Box>
                        ) : getHistoryData().length > 0 ? (
                            <TableContainer
                                component={Paper}
                                sx={{
                                    maxHeight: 400,
                                    boxShadow: "none",
                                }}
                            >
                                <Table
                                    stickyHeader
                                    aria-label="riwayat penyewaan table"
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                Nama
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                Harga
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                Awal Sewa
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                Akhir Sewa
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                                align="center"
                                            >
                                                Pax
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: 'bold'}} align="center">
                                                Keterangan
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {getHistoryData().map((sewa, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    "&:last-child td, &:last-child th":
                                                        { border: 0 },
                                                    "&:hover": {
                                                        backgroundColor:
                                                            "#fafafa",
                                                    },
                                                }}
                                            >
                                                <TableCell>
                                                    <Tooltip
                                                        title={sewa.penyewa}
                                                    >
                                                        <>
                                                            <Typography
                                                                className="table-cell-trucate"
                                                                sx={{
                                                                    color: "#0000EE",
                                                                }}
                                                            >
                                                                {sewa.penyewa}
                                                            </Typography>
                                                            <Typography
                                                                className="table-cell-trucate"
                                                                sx={{
                                                                    color: "#7C8883",
                                                                    fontWeight: 200,
                                                                    fontSize:
                                                                        "15px",
                                                                }}
                                                            >
                                                                {
                                                                    sewa.namaPerusahaan
                                                                }
                                                            </Typography>
                                                        </>
                                                    </Tooltip>
                                                </TableCell>

                                                <TableCell>
                                                    <Tooltip
                                                        title={toRupiah(
                                                            sewa.harga,
                                                        )}
                                                    >
                                                        <span className="table-cell-trucate">
                                                            {toRupiah(
                                                                sewa.harga,
                                                            )}
                                                        </span>
                                                    </Tooltip>
                                                </TableCell>

                                                <TableCell>
                                                    <Tooltip
                                                        title={formatDateTime(
                                                            sewa.awalSewa,
                                                        )}
                                                    >
                                                        <span className="table-cell-trucate">
                                                            {formatDateTime(
                                                                sewa.awalSewa,
                                                            )}
                                                        </span>
                                                    </Tooltip>
                                                </TableCell>

                                                <TableCell>
                                                    <Tooltip
                                                        title={formatDateTime(
                                                            sewa.akhirSewa,
                                                        )}
                                                    >
                                                        <span className="table-cell-trucate">
                                                            {formatDateTime(
                                                                sewa.akhirSewa,
                                                            )}
                                                        </span>
                                                    </Tooltip>
                                                </TableCell>

                                                <TableCell align="center">
                                                    <Tooltip
                                                        title={`${sewa.kapasitas} Orang`}
                                                    >
                                                        <span className="table-cell-trucate">
                                                            {sewa.kapasitas}{" "}
                                                            Orang
                                                        </span>
                                                    </Tooltip>
                                                </TableCell>

                                                <TableCell align="center">
                                                    <Tooltip title={`keterangan`}>
                                                        <span className="table-cell-trucate">
                                                            {sewa.keterangan}
                                                        </span>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <Box
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                                alignItems="center"
                                mt={10}
                            >
                                <Typography
                                    fontWeight={600}
                                    fontSize={25}
                                    textAlign="center"
                                >
                                    Belum ada Riwayat Penyewaan
                                </Typography>
                            </Box>
                        )}
                    </TabPanel>

                    <TabPanel value={value} index={isCurrentlyRented() ? 3 : 2}>
                        {isLoadingHistoryComingRoom ? (
                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                minHeight={200}
                            >
                                <Typography>
                                    Memuat data booking mendatang...
                                </Typography>
                            </Box>
                        ) : getHistoryComingData().length > 0 ? (
                            <TableContainer
                                component={Paper}
                                sx={{
                                    maxHeight: 400,
                                    boxShadow: "none",
                                }}
                            >
                                <Table
                                    stickyHeader
                                    aria-label="booking mendatang table"
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                Nama
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                Harga
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                Awal Sewa
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                            >
                                                Akhir Sewa
                                            </TableCell>
                                            <TableCell
                                                sx={{ fontWeight: "bold" }}
                                                align="center"
                                            >
                                                Pax
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {getHistoryComingData().map(
                                            (sewa, index) => (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        "&:last-child td, &:last-child th":
                                                            { border: 0 },
                                                        "&:hover": {
                                                            backgroundColor:
                                                                "#fafafa",
                                                        },
                                                    }}
                                                >
                                                    <TableCell>
                                                        <Tooltip
                                                            title={sewa.penyewa}
                                                        >
                                                            <>
                                                                <Typography
                                                                    className="table-cell-trucate"
                                                                    sx={{
                                                                        color: "#0000EE",
                                                                    }}
                                                                >
                                                                    {
                                                                        sewa.penyewa
                                                                    }
                                                                </Typography>
                                                                <Typography
                                                                    className="table-cell-trucate"
                                                                    sx={{
                                                                        color: "#7C8883",
                                                                        fontWeight: 200,
                                                                        fontSize:
                                                                            "15px",
                                                                    }}
                                                                >
                                                                    {
                                                                        sewa.namaPerusahaan
                                                                    }
                                                                </Typography>
                                                            </>
                                                        </Tooltip>
                                                    </TableCell>

                                                    <TableCell>
                                                        <Tooltip
                                                            title={toRupiah(
                                                                sewa.harga,
                                                            )}
                                                        >
                                                            <span className="table-cell-trucate">
                                                                {toRupiah(
                                                                    sewa.harga,
                                                                )}
                                                            </span>
                                                        </Tooltip>
                                                    </TableCell>

                                                    <TableCell>
                                                        <Tooltip
                                                            title={formatDateTime(
                                                                sewa.awalSewa,
                                                            )}
                                                        >
                                                            <span className="table-cell-trucate">
                                                                {formatDateTime(
                                                                    sewa.awalSewa,
                                                                )}
                                                            </span>
                                                        </Tooltip>
                                                    </TableCell>

                                                    <TableCell>
                                                        <Tooltip
                                                            title={formatDateTime(
                                                                sewa.akhirSewa,
                                                            )}
                                                        >
                                                            <span className="table-cell-trucate">
                                                                {formatDateTime(
                                                                    sewa.akhirSewa,
                                                                )}
                                                            </span>
                                                        </Tooltip>
                                                    </TableCell>

                                                    <TableCell align="center">
                                                        <Tooltip
                                                            title={`${sewa.kapasitas} Orang`}
                                                        >
                                                            <span className="table-cell-trucate">
                                                                {sewa.kapasitas}{" "}
                                                                Orang
                                                            </span>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ),
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <Box
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                                alignItems="center"
                                mt={10}
                            >
                                <Typography
                                    fontWeight={600}
                                    fontSize={25}
                                    textAlign="center"
                                >
                                    Belum ada Booking Mendatang
                                </Typography>
                            </Box>
                        )}
                    </TabPanel>

                    <ModalNonActiveRuangan
                        open={isOpenModalNonActiveRuangan}
                        onClose={closeModalNonActiveRuangan}
                        roomId={roomId}
                        nama={nama}
                        onDeleted={() => {
                            closeModalDetailRuangan();
                        }}
                    />

                    <ModalActiveRuangan
                        open={isOpenModalActiveRuangan}
                        onClose={closeModalActiveRuangan}
                        roomId={roomId}
                        nama={nama}
                        onDeleted={() => {
                            closeModalDetailRuangan();
                        }}
                    />
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default ModalDetailRuangan;
